"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ReactElementUtils = require("../../../utils/ReactElementUtils");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var styleKeys = ['theme', 'type', 'size', 'display'];
/**
 * Text label is used for styling text.  Don't confuse this with
 * <label> which is associate with input.
 * http://nutanix.design/2.0/#Foundation_Labels
 */

var TextLabel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TextLabel, _React$Component);

  function TextLabel() {
    _classCallCheck(this, TextLabel);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextLabel).apply(this, arguments));
  }

  _createClass(TextLabel, [{
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          className = _this$props.className,
          theme = _this$props.theme,
          type = _this$props.type,
          size = _this$props.size,
          display = _this$props.display,
          props = _objectWithoutProperties(_this$props, ["className", "theme", "type", "size", "display"]);
      /* eslint-enable */


      var styleProps = (0, _ReactElementUtils.getStyleProps)(styleKeys, this.props);
      return _react.default.createElement("span", _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-text-label ").concat(_ThemeManager.default.getVar('classPrefix')))
      }, styleProps, props));
    }
  }]);

  return TextLabel;
}(_react.default.Component);

exports.default = TextLabel;
TextLabel.TEXT_LABEL_TYPE = {
  INFO: 'info',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  TRIGGER: 'trigger'
};
TextLabel.TEXT_LABEL_SIZE = {
  SMALL: 'small',
  MEDIUM: 'medium'
};
TextLabel.TEXT_LABEL_THEME = {
  LIGHT: 'light',
  DARK: 'dark'
};
TextLabel.TEXT_LABEL_DISPLAY = {
  INLINE: 'inline',
  BLOCK: 'block'
};
TextLabel.defaultProps = {
  theme: TextLabel.TEXT_LABEL_THEME.LIGHT,
  type: TextLabel.TEXT_LABEL_TYPE.INFO,
  size: TextLabel.TEXT_LABEL_SIZE.MEDIUM
};
TextLabel.propTypes = {
  /**
   * Additional class name
   */
  className: _propTypes.default.string,

  /**
   * Style theme.
   */
  theme: _propTypes.default.oneOf([TextLabel.TEXT_LABEL_THEME.LIGHT, TextLabel.TEXT_LABEL_THEME.DARK]),

  /**
   * Size of text.
   */
  size: _propTypes.default.oneOf([TextLabel.TEXT_LABEL_SIZE.SMALL, TextLabel.TEXT_LABEL_SIZE.MEDIUM]),

  /**
   * Display label in inline or block format.
   */
  display: _propTypes.default.oneOf([TextLabel.TEXT_LABEL_DISPLAY.INLINE, TextLabel.TEXT_LABEL_DISPLAY.BLOCK]),

  /**
   * Type of label.
   */
  type: _propTypes.default.oneOf([TextLabel.TEXT_LABEL_TYPE.INFO, TextLabel.TEXT_LABEL_TYPE.PRIMARY, TextLabel.TEXT_LABEL_TYPE.SECONDARY, TextLabel.TEXT_LABEL_TYPE.ERROR, TextLabel.TEXT_LABEL_TYPE.WARNING, TextLabel.TEXT_LABEL_TYPE.SUCCESS, TextLabel.TEXT_LABEL_TYPE.TRIGGER])
};